
define('text!templates/messages_selector.html',[],function () { return '<input type="checkbox" id="messages-selector" title="Выделить все" /> Выбрать все';});

